import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs';
import { Project } from 'src/app/shared/models/project';
import { EEAOutputProjectStep1n2ResultSummaryColdef } from './eea-output-project-step1n2-result-summary.coldef';
import { EEAOutputProjectSummaryResultSurfaceWaterApiService } from '../../../../../shared/services/out-put-project/eea-output-project-step1n2-summary-result.api.service';
import { GridOptions, RowSelectedEvent } from 'ag-grid-community';
import { GridComponent } from 'src/app/shared/components/grid/grid.component';
import { EEAOutputProjectLogicService } from '../../eea-output-project.logic.service';

@Component({
  selector: 'app-eea-output-project-step1n2-result-summary',
  templateUrl: './eea-output-project-step1n2-result-summary.component.html',
  styleUrls: ['./eea-output-project-step1n2-result-summary.component.css']
})
export class EEAOutputProjectStep1n2ResultSummaryComponent implements OnInit, OnChanges {
  @Input() selectedProject?: Project;
  @Input() selectedModel?:string;
  @Input({required: true}) isProjectOwnershipValid: boolean = false;

  @ViewChild('grid') grid!: GridComponent;

  rowData: any;
  columDef: any;
  loading: boolean = false;

  sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: false,
          suppressValues: false,
          suppressPivots: false,
          suppressPivotMode: false,
          suppressColumnSelectAll: false,
          suppressColumnExpandAll: false,
          suppressFilters: false
        }
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        toolPanelParams: {
          suppressFilterSearch: false,
          suppressSelectAll: false
        }
      }
    ],
    defaultToolPanel: 'columns'
  };

  autoGroupColumnDef = {
    cellRendererParams: {
      suppressCount: true
    }
  };

  gridOptions: GridOptions = {
    processPivotResultColDef: (colDef: any) => {
      let typeIndicator = '';
      switch (colDef.field) {
        case 'MaxPecSw':         typeIndicator = 'Max'; break;
        case 'SevenDaysPecSwTwa': typeIndicator = '7d'; break;
        case 'PecSwTwa21Days':    typeIndicator = '21d'; break;
      }
      colDef.headerName = typeIndicator;
      colDef.headerComponent = 'compoundHeader';
    }
  };

  private eeaOutputProjectlogicService = inject(EEAOutputProjectLogicService);

  constructor(private step1n2ResultSummaryColdef: EEAOutputProjectStep1n2ResultSummaryColdef,
              private summaryResultService: EEAOutputProjectSummaryResultSurfaceWaterApiService) {
  }

  ngOnInit(): void {
    this.columDef = this.step1n2ResultSummaryColdef.getColumnsDefinition( this.isProjectOwnershipValid );
    if(this.selectedProject)
      this.getSummaryResult(this.selectedProject.projectPk);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedProject'].currentValue.projectPk) {
      this.getSummaryResult(changes['selectedProject'].currentValue.projectPk);
    }
  }

  getSummaryResult(projectPk: number) {
    if (projectPk != 0) {
      this.loading = true;
      this.summaryResultService
        .getSummariesResultsSurfaceWaterByModel(projectPk,this.selectedModel??"")
        .pipe(take(1))
        .subscribe((result: any) => {
           this.rowData = result.Value;
           this.refreshSelectedValuesTimeout();
           this.loading = false;
        });
    }
  }

  public onSelectedRowEvent( event: RowSelectedEvent ){
    this.eeaOutputProjectlogicService.setSmeSelectionResultsSw( event );
  }

  public onSelectedAllChanged( ){
    if( !this.grid ) return;
    this.eeaOutputProjectlogicService.setSmeSelectionsResultsSw( this.grid );
  }

  private refreshSelectedValuesTimeout(): void {
    setTimeout(() => {
      this.refreshSelectedValues();
    }, 75);
  }

  private refreshSelectedValues(): void {
    if( !this.grid ) return;
    this.grid.refreshSelectedValues( 'EeaSmeSelection' );
  }
}
